<template>
    <div class="split-Section" :class="{'has-link': link}" @click="$router.push(link)">
        <div class="columns is-gapless" :class="{ 'split-Section--pictureLeft': alignLeft }">
            <div class="column" :class="{ 'split-Section__box-shadow': alignLeft }">
                <figure class="image has-border split-Section__Img">
                    <LazyLoadedImage :src="imgSrc" alt="Placeholder image"></LazyLoadedImage>
                </figure>
            </div>
            <div class="column has-text-light"
                 :class="{'has-background-grey-dark':dark,  'split-Section__box-shadow': !alignLeft}">
                <div class="column content ml-4 mr-5 py-6">
                    <div lang="de" class="title is-size-4 is-size-2-desktop hyphenate" :class="{'has-text-light':dark}">
                        {{ title }}
                    </div>
                    <div class="subtitle is-uppercase hyphenate" :class="{'has-text-light':dark}">{{ subtitle }}</div>
                    <div class="content pt-3 rich-text hyphenate" :class="{'has-text-grey-darker':!dark}" v-html="text">
                    </div>
                </div>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
import LazyLoadedImage from "../shared/LazyLoadedImage";

export default {
    name: "SplitSection",
    components: {LazyLoadedImage},
    props: {
        contentData: {
            type: Object,
            required: true
        }
    },
    computed: {
        imgSrc() {
            if (this.contentData.content.gallery.rows[1]) {
                return this.contentData.content.gallery.rows[1].columns[1].publicUrl
            }
            return "";
        },
        title() {
            return this.contentData.content.header;
        },
        link(){
            return this.contentData.content.headerLink.url || null;
        },
        subtitle() {
            return this.contentData.content.subheader;
        },
        text() {
            return this.contentData.content.bodytext.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },
        dark() {
            return this.contentData.appearance.layout === 'layout-1';
        },
        alignLeft() {
            return this.contentData.content.gallery.position.horizontal === 'right';
        },
    }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: $tablet) {
    .split-Section {
        margin: 5% 15%;

        &--pictureLeft {
            flex-direction: row-reverse;
        }

        &__Img {
            position: relative;
            overflow: hidden;
            height: 100%;

            img {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 100ms $easing;
            }
        }

        &__box-shadow {
            -webkit-box-shadow: 150px 48px 0px 0px rgba(196, 188, 196, 0.49);
            -moz-box-shadow: 150px 48px 0px 0px rgba(196, 188, 196, 0.49);
            box-shadow: 150px 48px 0px 0px rgba(196, 188, 196, 0.49);
        }

        &.has-link:hover {
            cursor: pointer;

            .split-Section__Img {
                img {
                    transform: scale(1.1);
                    transition: transform 150ms $easing;
                }
            }
        }
    }

}
</style>